import { useSharedAPI } from "@certn/api";
import { useJsonForms } from "@jsonforms/react";
import get from "lodash.get";
import { useMemo } from "react";

import { SearchableSelectControl } from "./SearchableSelectControl";
import { getSubdivisionKeys } from "./subdivisionKeys";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function RegionSelectControl(props: CascadiaControlProps) {
  const { options } = props.uischema;
  const context = useJsonForms();
  const country = get(
    context?.core?.data,
    props.uischema?.options?.relatedCountryField
  );

  const { data: subdivisions, isLoading } = useSharedAPI(
    "/api/internal/shared/country-subdivisions/",
    {
      alpha_2: country ?? "CA",
    }
  );

  const subdivisionKeys = getSubdivisionKeys(country);

  const sortedSubdivisions = useMemo(
    () =>
      subdivisions
        ?.filter((subdivision) => subdivisionKeys.includes(subdivision.type))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((subdivision) => ({
          value: subdivision.code,
          label: subdivision.name.split(";")[0].split("[")[0], // cleanup names (ex. "Wales; Cymru" & "Wales [Cymru GB-CYM]") Go Wales!!! 🏴󠁧󠁢󠁷󠁬󠁳󠁿
        })) || [],
    [subdivisions, subdivisionKeys]
  );

  const disable =
    options?.relatedCountryField && !country && options?.disableWithoutCountry;
  const isRequired =
    options?.is_required === undefined
      ? sortedSubdivisions.length > 0
      : options.is_required;

  return (
    <SearchableSelectControl
      {...props}
      items={sortedSubdivisions || []}
      required={isRequired}
      isLoading={isLoading}
      enabled={props.enabled && !disable}
    />
  );
}

RegionSelectControl.displayName = "RegionSelectControl";

export const RegionSelectRenderer =
  withCascadiaControlProps(RegionSelectControl);
